import React from 'react';

const SpecialityCell = ({ row }) => {
  const specialty = row?.specialty || row?.provider?.specialty || 'n/a';

  return (
    <span className="line-clamp-2 text-sm text-secondary">
      {specialty}
    </span>
  );
};

export default SpecialityCell;
